import { createAction } from 'redux-actions'

const ns = 'inbox/'

export const getUserNotifications = createAction(`${ns}GET_USER_NOTIFICATIONS`)
export const getUserNotificationsSuccess = createAction(`${ns}GET_USER_NOTIFICATIONS_SUCCESS`)
export const getUserNotificationsFail = createAction(`${ns}GET_USER_NOTIFICATIONS_FAIL`)

export const markUserNotificationRead = createAction(`${ns}MARK_USER_NOTIFICATION_READ`)
export const markUserNotificationReadSuccess = createAction(`${ns}MARK_USER_NOTIFICATION_READ_SUCCESS`)
export const markUserNotificationReadFail = createAction(`${ns}MARK_USER_NOTIFICATION_READ_FAIL`)
